<h1 mat-dialog-title>Update customer?</h1>
<mat-dialog-content>
  <p class="secondary-text sub-title">
    You are updating customer:
  </p>
  <div class="content">
    <div fxLayout="row wrap" fxFlex="100">

      <div *ngIf="data.form.controls.method && !data.form.controls.method.pristine" fxLayout="column" fxFlex="100"
        fxFlex.gt-sm="50" class="layout padding-vertical-md">
        <div>{{data.form.value.method | enumValueLabel : VerificationMethod : VerificationMethodLabel }}</div>
        <div class="mat-caption"> Method </div>
      </div>

      <div *ngIf="data.form.controls.status && !data.form.controls.status.pristine" fxLayout="column" fxFlex="100"
        fxFlex.gt-sm="50" class="layout padding-vertical-md">
        <div>{{data.form.value.status | enumValueLabel : VerificationStatus : VerificationStatusLabel || 'Pending'}}</div>
        <div class="mat-caption"> Status </div>
      </div>

    </div>
  </div>
</mat-dialog-content>

<div mat-dialog-actions class="flex row end-center">
  <button mat-button [mat-dialog-close]="false">Cancel</button>
  <button mat-button [mat-dialog-close]="true" color="primary">Ok</button>
</div>